import AppListing from '../app-components/Listing/AppListing';

Vue.component('maternity-leave-listing', {
    mixins: [AppListing]
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/maternity-leave/Listing.js